import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Stack, Typography } from "@mui/material";
export default function VendorApprovalCard({
  approvals,
}: VendorApprovalCardProps) {
  return (
    <Box p={2}>
      <Stack spacing={1}>
        {approvals?.map((source, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="subtitle1">{source.name}</Typography>
            {source.approved ? (
              <CheckCircleIcon color="success" />
            ) : (
              <CancelIcon color="error" />
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

interface VendorApprovalCardProps {
  approvals: any[];
}
